/* eslint-disable @typescript-eslint/camelcase */
import { Box, Flex } from '@chakra-ui/core'
import React from 'react'
import { Stats } from '..'
import { StatCardProps } from '../../../Analytics/components/Stats'
import {
  Enum_Task_Status,
  useGetDataCollectorTasksLeaderBoardQuery,
  useGetNumberDataCollectorsTasksQuery
} from '../../../../generated/graphql'
import { ChartSwitch } from '../../../Analytics/components/Charts'
import { Activity } from 'react-feather'

type MetricsProps = {
  totalNumberOfTasks: number
  filters?: any
  loading?: boolean
}
const Metrics: React.FC<MetricsProps> = ({ totalNumberOfTasks, filters, loading }) => {
  const { data } = useGetDataCollectorTasksLeaderBoardQuery({
    fetchPolicy: 'network-only',
    variables: {
      filters: {
        ...filters
      }
    }
  })
  const { data: numberOfApprovedTasksData, loading: loadingApproved } =
    useGetNumberDataCollectorsTasksQuery({
      variables: {
        filters: {
          ...filters,
          status: Enum_Task_Status.Completed
        }
      }
    })
  const { data: numberOfRejectedTasksData, loading: loadingRejected } =
    useGetNumberDataCollectorsTasksQuery({
      variables: {
        filters: {
          ...filters,
          status: Enum_Task_Status.Rejected
        }
      }
    })
  const { data: numberOfEditedTasksData, loading: loadingEdited } =
    useGetNumberDataCollectorsTasksQuery({
      variables: {
        filters: {
          ...filters,
          status: Enum_Task_Status.MoreInfoRequested
        }
      }
    })
  const { data: numberOfPendingTasksData, loading: loadingPending } =
    useGetNumberDataCollectorsTasksQuery({
      variables: {
        filters: {
          ...filters,
          status: Enum_Task_Status.Pending
        }
      }
    })

  const numberOfApprovedTasks = numberOfApprovedTasksData?.getNumberDataCollectorsTasks || 0
  const numberOfRejectedTasks = numberOfRejectedTasksData?.getNumberDataCollectorsTasks || 0
  const numberOfEditedTasks = numberOfEditedTasksData?.getNumberDataCollectorsTasks || 0
  const numberOfPendingTasks = numberOfPendingTasksData?.getNumberDataCollectorsTasks || 0

  const numberOfTasksPerDataCollector =
    data?.getDataCollectorTasksLeaderBoard?.map((data) => ({
      name: `${data?.dataCollector?.attributes?.firstName} ${data?.dataCollector?.attributes?.lastName}`,
      count: data?.count || 0
    })) || []

  const stats: StatCardProps[] = React.useMemo(
    () => [
      {
        title: 'Total Tasks',
        icon: Activity,
        loading: loading,
        value: `${totalNumberOfTasks} tasks`
      },
      {
        title: 'Approved Tasks',
        icon: Activity,
        loading: loadingApproved,
        value: `${numberOfApprovedTasks} tasks`
      },
      {
        title: 'Rejected Tasks',
        icon: Activity,
        loading: loadingRejected,
        value: `${numberOfRejectedTasks} tasks`
      },
      {
        title: 'Tasks Edited',
        icon: Activity,
        loading: loadingEdited,
        value: `${numberOfEditedTasks} tasks`
      },
      {
        title: 'Tasks Submitted',
        icon: Activity,
        loading: loadingPending,
        value: `${numberOfPendingTasks} tasks`
      }
    ],
    [
      totalNumberOfTasks,
      numberOfApprovedTasks,
      numberOfRejectedTasks,
      numberOfEditedTasks,
      numberOfPendingTasks,
      loadingApproved,
      loadingRejected,
      loadingEdited,
      loadingPending,
      loading
    ]
  )
  return (
    <Box w="100%">
      <Flex align="center" mb={4}>
        <Stats stats={stats} alignItems="flex-start" />
      </Flex>
      <ChartSwitch
        data={numberOfTasksPerDataCollector || []}
        xKey="name"
        yKey="count"
        title="Top Performing Data Collectors"
        defautChartType="bar"
        bg="transparent"
      />
    </Box>
  )
}

export default Metrics
